import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, LineReveal } from "./Reveal";

export const CtaSection = ({
  lines = ["Butuh pendampingan hukum?", "Bicara dengan kami hari ini."],
  testid = "cta-section",
}) => (
  <section
    data-testid={testid}
    className="relative overflow-hidden border-t border-white/10 bg-[#0A0A0A]"
  >
    <div className="gold-radial pointer-events-none absolute inset-0" aria-hidden="true" />
    <div className="relative mx-auto w-full max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
      <h2 className="max-w-4xl font-serif text-4xl leading-[1.05] text-[#F5F5F5] sm:text-5xl lg:text-7xl">
        <LineReveal inView lines={lines} lineClassName="last:text-gold last:italic" />
      </h2>
      <FadeUp delay={0.3}>
        <p className="mt-8 max-w-xl text-base font-light leading-relaxed text-[#A3A3A3] md:text-lg">
          Konsultasi awal tanpa biaya. Ceritakan persoalan Anda, kami yang
          memetakan jalan hukumnya.
        </p>
        <Link
          to="/kontak"
          data-testid={`${testid}-button`}
          className="group mt-10 inline-flex items-center gap-3 bg-gold px-8 py-4 text-[13px] font-semibold uppercase tracking-[0.2em] text-ink transition-all duration-300 hover:-translate-y-0.5 hover:bg-gold-light"
        >
          Ajukan Konsultasi
          <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </FadeUp>
    </div>
  </section>
);
